import type { NotificationGetNotifications200NotificationsItemSourceSourceUser } from './notificationGetNotifications200NotificationsItemSourceSourceUser';

/**
 * 알림 소스 정보
 */
export type NotificationGetNotifications200NotificationsItemSource = {
  /** 알림을 발생시킨 사용자 정보 */
  sourceUser?: NotificationGetNotifications200NotificationsItemSourceSourceUser;
  /** 알림을 발생시킨 사용자 ID */
  sourceUserId?: number;
};
